let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aU943")).then(() => parcelRequire('10YMd'));